import React from "react";
import { Grid, Typography } from "@material-ui/core";
import Spinners from "react-loader-spinner";
import { useTranslation } from "react-i18next";

const ContentLoadingView = () => {
  const { t } = useTranslation();

  return (
    <Grid container direction="column" className="content-loading-view">
      <Spinners type="Bars" visible={true} className="spinner" />
      <Typography className="typography-body-1 capitalized-text">
        {`${t("common.initializing")}...`}
      </Typography>
    </Grid>
  );
};

export default ContentLoadingView;
